import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { NoResultContainer } from './style';
import Text from '../Text';

const NoResult = ({ text, isSpinning, modalIsOpen }) => (
  <NoResultContainer className={modalIsOpen ? 'no-result-modal' : ''}>
    {isSpinning ? (
      <Text type="h2" className="dots">
        In caricamento <span className="dot">.</span>
        <span className="dot">.</span>
        <span className="dot">.</span>
      </Text>
    ) : (
      <Text type="h2">{text || 'Nessun risultato'}</Text>
    )}
  </NoResultContainer>
);

NoResult.propTypes = {
  text: PropTypes.string,
  // HOC (connect, state)
  isSpinning: PropTypes.bool,
  modalIsOpen: PropTypes.bool,
};

export default connect((state) => {
  const {
    modal: { isOpen: modalIsOpen },
    loader: { isSpinning },
  } = state.app;
  return { modalIsOpen, isSpinning };
})(NoResult);
